import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=432e2b28&"
import script from "./appMain.vue?vue&type=script&lang=js&"
export * from "./appMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports